<div class="label">{{ label }}</div>
<div #container>
  <div class="control">
    <textarea
      #input
      type="text"
      [value]="_value"
      (blur)="markAsTouched()"
      (input)="handleInputChange(input.value)"
      rows="1"
      [readonly]="static"
    ></textarea>
    <div class="suffix">
      @if (firstError && touched) {
        <mat-icon color="warn" [@fadeIn]>error </mat-icon>
      }
    </div>
  </div>

  @if (!(firstError && touched)) {
    <div class="hint">
      {{ hint }}
    </div>
  }

  @if (firstError && touched) {
    <ng-container [ngTemplateOutlet]="firstError.template"></ng-container>
  }
</div>
